export const booking = {
    namespaced: true,
    state: () => ({
        data: {}
    }),
    mutations: {
        setData(state,data){
            state.data = data;
            // console.log(data);
        },
        resetData(state){

            const size = Object.keys(state.data).length;
            if(size){
                for (const key in state.data){
                    delete state.data[key]
                }
            }
        }
    },
    actions: {
        setData({ commit }, data) {
            // commit("resetData");
            commit("setData", data.bookingsData);
        }
    }
};